import { Badge } from '@/components/ui/badge'
import { AlertCircle } from 'lucide-react'

/**
 * Help content specific to email campaigns
 */
export function EmailCampaignHelp() {
    return (
        <>
            <h3 className="font-medium text-lg mb-2">Publishing Email Campaigns</h3>
            <ol className="list-decimal pl-5 space-y-3 mb-4">
                <li>
                    <strong>Copy HTML:</strong> Use the <Badge variant="outline" className="ml-1 mr-1 font-normal">Copy Source</Badge> button to copy the HTML code
                    for your email campaign.
                </li>
                <li>
                    <strong>Integration with Email Platforms:</strong> Paste the copied HTML into your email marketing platform (Mailchimp, HubSpot, etc.)
                    as an HTML email template.
                </li>
                <li>
                    <strong>Test Email:</strong> Send a test email to yourself to verify all links, images, and formatting display correctly.
                </li>
                <li>
                    <strong>Email Preview:</strong> Use the <Badge variant="outline" className="ml-1 mr-1 font-normal">Share & Embed → Open as Webpage</Badge> option to see how the email 
                    will look as a webpage for recipients who click "View in browser".
                </li>
            </ol>
            
            <div className="bg-amber-50 dark:bg-amber-950/30 p-3 rounded-md border border-amber-200 dark:border-amber-800 mb-4">
                <h4 className="font-medium text-amber-800 dark:text-amber-400 flex items-center gap-2 mb-2">
                    <AlertCircle className="h-4 w-4" />
                    Email Compatibility
                </h4>
                <p className="text-sm text-amber-700 dark:text-amber-300">
                    The generated email HTML is designed to be compatible with most email clients, but we recommend testing with services like 
                    Litmus or Email on Acid if you're targeting a wide variety of email clients. Some advanced styling may need adjustment.
                </p>
            </div>
        </>
    )
}